exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".subscriptionOption-32_Ap {\n  clear: both;\n  list-style: none;\n  padding-bottom: 10px;\n  clear: both;\n}\n.icon-36CkA {\n  float: left;\n  margin-right: 10px;\n  width: 20px;\n}\n.link-1SK5P {\n  font-size: 12px;\n  color: #727272;\n}\n.link-1SK5P:hover {\n  color: #262626;\n}", ""]);

// Exports
exports.locals = {
	"subscriptionOption": "subscriptionOption-32_Ap",
	"icon": "icon-36CkA",
	"link": "link-1SK5P"
};